import { render, staticRenderFns } from "./franchisee-view.vue?vue&type=template&id=3b2e0c1f&scoped=true&"
import script from "./franchisee-view.vue?vue&type=script&lang=js&"
export * from "./franchisee-view.vue?vue&type=script&lang=js&"
import style0 from "./franchisee-view.vue?vue&type=style&index=0&id=3b2e0c1f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2e0c1f",
  null
  
)

export default component.exports